import React from 'react';
import * as actions from '../../store/global/action_creators_consts';
import ConfirmDialog from '../dialog/ConfirmDialog';

const SubscriptionRequiredDialog = ({errorMessage}) => {

    const goToLicenseSettings = () => {
        actions.routesContainer.routes.push("/license");
    };

    return (
        <ConfirmDialog
            title="Subscription Required"
            onConfirm={goToLicenseSettings}
            confirmText="Go to License Settings"
        >
            <p className="wordwrap">{errorMessage}</p>
        </ConfirmDialog>
    );
};

export default SubscriptionRequiredDialog;

